import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  requestLocation(event) {
    // Only intercept if near_me is being activated (not deactivated)
    const url = new URL(event.currentTarget.href, window.location.origin)
    const nearMe = url.searchParams.get('near_me')
    
    if (!nearMe) {
      // User is turning OFF near_me, let the link work normally
      return
    }
    
    event.preventDefault()
    
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser")
      return
    }
    
    // Store reference to the link element
    const linkElement = event.currentTarget
    const originalText = linkElement.innerHTML
    
    // Show loading state
    linkElement.innerHTML = '<i class="fas fa-spinner fa-spin mr-1.5 text-xs"></i> Locating...'
    linkElement.style.pointerEvents = 'none'
    
    // Get default radius from URL or use 20km
    const defaultRadius = url.searchParams.get('radius') || '20'
    
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude
        const lng = position.coords.longitude
        
        // Append coordinates to URL
        url.searchParams.set('latitude', lat)
        url.searchParams.set('longitude', lng)
        
        // Ensure radius is set
        if (!url.searchParams.get('radius')) {
          url.searchParams.set('radius', defaultRadius)
        }
        
        // Try to get location name via reverse geocoding
        try {
          const locationName = await this.reverseGeocode(lat, lng)
          if (locationName) {
            url.searchParams.set('near_me_location', locationName)
          }
        } catch (e) {
          console.warn('Reverse geocoding failed:', e)
        }
        
        // Restore button state
        linkElement.innerHTML = originalText
        linkElement.style.pointerEvents = ''
        
        // Navigate
        window.location.href = url.toString()
      },
      (error) => {
        // Error - restore button and show message
        linkElement.innerHTML = originalText
        linkElement.style.pointerEvents = ''
        
        let message = "Unable to get your location"
        switch(error.code) {
          case error.PERMISSION_DENIED:
            message = "Please allow location access to use this feature"
            break
          case error.POSITION_UNAVAILABLE:
            message = "Location information unavailable"
            break
          case error.TIMEOUT:
            message = "Location request timed out"
            break
        }
        alert(message)
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 300000 // Cache for 5 minutes
      }
    )
  }
  
  async reverseGeocode(lat, lng) {
    // Use OpenStreetMap Nominatim (free, no API key)
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=10`,
      { headers: { 'Accept-Language': document.documentElement.lang || 'en' } }
    )
    
    if (!response.ok) return null
    
    const data = await response.json()
    
    // Return city, town, or village name
    return data.address?.city || 
           data.address?.town || 
           data.address?.village || 
           data.address?.municipality ||
           data.address?.county ||
           null
  }
}
